import { refProcess } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { ProcessDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["PROCESS_QUEUE_URL"]

export const getRefProcessData = async (
  tx: DbTransaction,
  id: string,
): Promise<ProcessDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refProcess.id,
      processCode: refProcess.processCode,
      processName: refProcess.processName,
      unCode: refProcess.unCode,
      mostCommon: refProcess.mostCommon,
      ranking: refProcess.ranking,
      commodityAp: refProcess.commodityAp,
      commodityPhyto: refProcess.commodityPhyto,
      active: refProcess.active,
      updatedAt: refProcess.updatedAt,
      updatedBy: refProcess.updatedBy,
    })
    .from(refProcess)
    .where(eq(refProcess.id, parseInt(id)))

  if (!row) {
    console.error(`RefProcess with id ${id} not found`)
    return
  }

  const refProcessDoc: ProcessDoc = {
    id: row.id.toString(),
    process_code: row.processCode,
    process_name: row.processName,
    un_code: row.unCode,
    most_common: row.mostCommon,
    ranking: row.ranking,
    commodity_ap: row.commodityAp,
    commodity_phyto: row.commodityPhyto,
    active: row.active,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refProcessDoc,
  })

  return refProcessDoc
}

export const saveRefProcessToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefProcessData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}

export const saveRefProcessToSearchByCode = async (
  tx: DbTransaction,
  processCode: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const [row] = await tx
    .select({ id: refProcess.id })
    .from(refProcess)
    .where(eq(refProcess.processCode, processCode))

  if (!row) {
    console.error(`RefProcess with processCode ${processCode} not found`)
    return
  }

  const doc = await getRefProcessData(tx, row.id.toString())

  if (!doc) {
    console.error(`Failed to prepare document for processCode: ${processCode}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
